import BarChart from '@/features/battery/BarChart';
import {
    CollectingDataBanner,
    CRITICAL,
    LOW_MILEAGE,
    NO_DATA,
    NoData,
    OK,
    WARNING,
} from '@/features/batteryOverview/utils/BatteryDataUtils';

type StateOfHealthStatus =
    | typeof OK
    | typeof WARNING
    | typeof CRITICAL
    | typeof NO_DATA
    | typeof LOW_MILEAGE
    | null
    | undefined;

type SoHValueProps = {
    status: StateOfHealthStatus;
    percentage?: number;
    textSize?: number;
    valueClassName?: string;
    noDataClassName?: string;
};

const SoHValue = ({ status, percentage, textSize = 18, valueClassName, noDataClassName = '' }: SoHValueProps) => {
    if (status === NO_DATA) {
        return (
            <div className={noDataClassName}>
                <NoData textSize={textSize} />
            </div>
        );
    }

    if (status === LOW_MILEAGE) {
        return <CollectingDataBanner textSize={textSize} />;
    }

    if (status && [OK, WARNING, CRITICAL].includes(status)) {
        return (
            <BarChart
                value={percentage !== undefined ? Math.round(percentage * 10) / 10 : undefined}
                status={status.toUpperCase()}
                valueClassName={valueClassName}
            />
        );
    }

    return null;
};

export default SoHValue;
